var _rule = require("../rule.js");

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _rule2.default.makeRule({
    name: "math-align-linebreaks",
    severity: _rule2.default.Severity.WARNING,
    selector: "blockMath",
    pattern: /\\begin{align}.*[^\\](\\{2,3}[^\\]|\\{5,}).*\\end{align}/,
    message: "Use four backslashes between lines of an align block"
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/gorgon/rules/math-align-linebreaks.js
 ** module id = 224
 ** module chunks = 0 2
 **/